<template>
  <div class="relative full" v-if="list && APIs">
    <div class="absolute top-0 left-0 w-full h-full">
      <EngineScissor :APIs="APIs" class="full"></EngineScissor>
    </div>
    <div class="absolute top-0 left-0 w-full h-full" v-show="false">
      <div :key="li._id + 'webgl'" v-for="(li) in list">
        <GLItem v-if="getDomID(li) && li.idx % 2 === 0" :domID="getDomID(li)" :li="li" :APIs="APIs"></GLItem>
        <GLItem2 v-if="getDomID(li) && li.idx % 2 === 1" :domID="getDomID(li)" :li="li" :APIs="APIs"></GLItem2>
      </div>
    </div>
    <div class="absolute top-0 left-0 h-full w-full scrolling-touch overflow-y-auto" ref="scroller">
      <div class=" max-w-4xl mx-auto">
        <div class="h-32 lg:h-56 border-gray-700 w-full border-b flex items-center justify-center">
          <input class=" border-b " type="text" v-model="newText" />
          <button class="btn btn-outline" @click="onSubmit">Submit</button>
        </div>
        <DOMItem :map="map" :key="li._id + 'dom'" @select="$emit('select', $event)" :li="li" v-for="li in list">
        </DOMItem>
        <div class=" cursor-pointer select-none h-32 lg:h-56 border-gray-700 w-full border-b flex items-center justify-center" @click="$emit('loadmore')">
          Load More...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    APIs: {},
    list: {}
  },
  components: {
    DOMItem: require('./DOMItem.vue').default,
    EngineScissor: require('./EngineScissor.vue').default,
    GLItem: require('./GLItem.vue').default,
    GLItem2: require('./GLItem2.vue').default
  },
  watch: {
    list () {
      this.$forceUpdate()
    }
  },
  data () {
    return {
      newText: 'newText',
      map: new Map()
    }
  },
  mounted () {
    window.addEventListener('scroll-to-bottom', () => {
      this.$nextTick(() => {
        if (this.$refs['scroller']) {
          this.$refs['scroller'].scrollTop = this.$refs['scroller'].scrollHeight
        }
      })
    }, false)
  },
  methods: {
    onSubmit () {
      this.$emit('create', { text: this.newText })
    },
    getDomID (li) {
      return this.map.get(li._id)
    }
  }
}
</script>

<style>

</style>
